import { useState } from 'react';
import QuickQuestions from '@components/Features/QuickQuestions';
import LinkLibrary from '@components/Features/LinkLibrary';
import FantasticFans from '@components/Features/FantasticFans';
import { SimpleCredits } from '@components/Features/Credits/SimpleCredits';
import SettingSwitch from '@molecules/SettingSwitch';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger
} from '@atoms/new/dropdown';
import Button from '@atoms/new/button';
import {
  CaretDownIcon as KeyboardArrowDownIcon,
  CheckIcon as DoneRounded
} from '@phosphor-icons/react';

import {
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@atoms/new/modal';
import Image from 'next/image';
import { getDefaultTitle } from '@components/Presentation/helpers';
import { linkCategories, fantasticFansWinnerOptions } from '@services/interactions.service';
import SelectableRadioGroup from '@atoms/new/SelectableRadioGroup';

const TrackInteractionsModal = (props) => {
  const interactionComponent = {
    'Quick Questions': <QuickQuestions {...props} questionData={[]} totalQuestions={0} isTrackModal={true} />,
    linkLibrary: <LinkLibrary {...props} linkData={[]} totalLinks={0} isTrackModal={true} />,
    fantasticFans: <FantasticFans {...props} isTrackModal={true} />,
    credits: <SimpleCredits feature="credits" theme={props?.theme ?? null} featureColors={props?.currentRosFeature?.color} setting={props?.currentRosFeature?.setting} title={props?.currentRosFeature?.title} />,
    blankScreen: <div className='w-full h-full' />
  };
  const updateSetting = (key, data) => {
    props.setCurrentRosFeature(prevFeature => ({
      ...prevFeature,
      setting: { ...prevFeature.setting, [key]: data }
    }));
  };

  return (
    <ModalContent className="text-default-900">
      <ModalHeader className="w-full flex flex-col items-center justify-center">
        <div className='w-full flex justify-between pl-4.5 pr-8 items-center'>
          <h1 className="text-xl font-semibold">{getDefaultTitle(props?.openTrackModal)}</h1>
          <Dropdown
            placement='bottom-end'
            selectionMode='single'
          >
            <DropdownTrigger>
              <Button
                kind='tertiary'
                endContent={<KeyboardArrowDownIcon size={16} />}
              >
                Settings
              </Button>
            </DropdownTrigger>

            <SettingsList setting={props?.currentRosFeature?.setting} updateSetting={updateSetting} openTrackModal={props?.openTrackModal} />
          </Dropdown>
        </div>
      </ModalHeader>
      <ModalBody className="pt-4 no-scrollbar1" id="trackModalScrollBody">
        {interactionComponent[props?.openTrackModal]}
      </ModalBody>
      <ModalFooter className="pt-2">
      </ModalFooter>
    </ModalContent>
  );
};

export default TrackInteractionsModal;

const SettingsList = ({ setting, updateSetting, openTrackModal }) => {
  const [selectedFilter, setSelectedFilter] = useState({
    name: 'All',
    img: '/images/linkLibrary/HyperLink.svg'
  });

  return (
    <DropdownMenu className='w-[250px]' closeOnSelect={false}>
      {openTrackModal === 'Quick Questions' ? (
        <DropdownItem key='showUserName' className="data-[hover=true]:bg-transparent" >
          <p className={'text-xs font-semibold text-default-700 mb-2'}>
            Audience responses
          </p>
          <SettingSwitch
            label="Show username"
            tooltipContent={'Each question will show the username of the commenter.'}
            settingKey={'showUserName'}
            settingValue={setting?.showUserName}
            onChangeHandler={(key) => updateSetting(key, !setting?.showUserName)}
          />
        </DropdownItem>
      ) :
        openTrackModal === 'linkLibrary' ?
          <DropdownItem className='data-[hover=true]:bg-transparent'>
            <p className={'text-xs font-semibold text-default-700 mb-2'}>
              Select platform
            </p>
            <Dropdown>
              <DropdownTrigger>
                <Button
                  className='w-full justify-start'
                  kind='tertiary'
                  endContent={<KeyboardArrowDownIcon size={16} />}
                  startContent={
                    <Image
                      src={selectedFilter?.img}
                      alt={selectedFilter?.name}
                      width={20}
                      height={20}
                    />
                  }
                >
                  <span className="flex-1 text-left text-sm">
                    {selectedFilter?.name}
                  </span>
                </Button>
              </DropdownTrigger>
              <DropdownMenu>
                {Object.entries(linkCategories).map(([k, v]) => (
                  <DropdownItem
                    key={k}
                    value={k}
                    onAction={() => { updateSetting('LinkType', k); setSelectedFilter(v); }}
                    startContent={
                      <Image
                        src={v.img}
                        alt={v.name}
                        width={20}
                        height={20}
                      />
                    }
                    endContent={
                      k === setting?.LinkType ? (
                        <DoneRounded size={16} />
                      ) : null
                    }
                  >
                    {v.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </DropdownItem>
          : openTrackModal === 'fantasticFans' ?
            <DropdownItem className='data-[hover=true]:bg-transparent'>
              <p className={'text-xs font-semibold text-default-700 mb-2'}>
                Show top
              </p>
              <SelectableRadioGroup
                options={fantasticFansWinnerOptions}
                value={setting.fantasticFansShowWinners || 'all'}
                onChange={(value) => updateSetting('fantasticFansShowWinners', value)}
              />
            </DropdownItem>
            : openTrackModal === 'credits' ?
              <DropdownItem className='data-[hover=true]:bg-transparent'>
                <p className={'text-xs font-semibold text-default-700 mb-2'}>Show top</p>
                <SelectableRadioGroup
                  options={fantasticFansWinnerOptions}
                  value={setting.creditsShowTop || 'all'}
                  onChange={(value) => updateSetting('creditsShowTop', value)}
                />
              </DropdownItem>
              : null
      }
    </DropdownMenu>
  );
};
